import { Link } from 'react-router-dom';
import React from "react";
import { useEffect, useState } from "react";
import { BaseUrl } from "../../helper/BaseUrl";
import { fetchJson } from "../../helper/fetchJson";
import HydrationSafeSlider from '../../components/HydrationSafeSlider';
const settings = {
    slidesToShow: 3,
    slidesToScroll: 1,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseonhover: false,
    infinite: true,
    centerMode: true,
    centerPadding: '0',
    arrows: false,
    dots: false,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3
            }
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 1,
                centerPadding: '10px'
            }
        }
    ],
};

const normalizeCardDescription = (value) => {
    let html = String(value || "").trim().replace(/<[^>]*$/, "");
    const openParagraphs = (html.match(/<p(?:\s[^>]*)?>/gi) || []).length;
    const closedParagraphs = (html.match(/<\/p>/gi) || []).length;

    if (openParagraphs > closedParagraphs) {
        html += "</p>".repeat(openParagraphs - closedParagraphs);
    }

    return html;
};

export default function HomeInsight({ initialData }) {
    const [allData, setAllData] = useState(initialData || []);
    // API Calling
    const fetcher = async () => {
        try {
            const result = await fetchJson(`${BaseUrl}/api/aiblogs`);

            if (result.blogs === false) {
                throw new Error(`API error: ${result.message}`);
            }
            setAllData(result.blogs);
        } catch (error) {
            console.error('Fetch error:', error.message);
        }
    };

    useEffect(() => {
        if (!initialData?.length) {
            fetcher();
        }
    }, [initialData])

    if (!allData) {
        return <div style={{ height: "100vh", width: "100%" }}></div>;
    }
    return (
        <>
            <section className="blog-section space">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-12 col-lg-7">
                            <div className="heading-gap heading-center">
                                <h3 className="heading ">Explore Expert <br /> Insights & Key Resources</h3>
                            </div>
                        </div>
                    </div>
                    <div className="wrapper">

                        <HydrationSafeSlider className="blog-slider" {...settings}>
                            {allData && allData.map((blog, i) => (
                                <div className="outer-wrapper" key={i}>
                                    <div className="blog-img-wrapper">
                                        <img src={`${BaseUrl}${blog.image}`} className="img-responsive blog-img" alt={blog.name} loading="lazy" />
                                    </div>
                                    <div className="main-content">
                                        <span className="home-blog-cat">{blog.category_name}</span>
                                        <label className="home-blog-title">{blog?.name?.slice(0, 80) + "..."}</label>
                                        <div dangerouslySetInnerHTML={{ __html: normalizeCardDescription(blog.description) }} />
                                        <Link className="univarsal-link" to={`/blogs/${blog.slug}`} >
                                            <small>Read Insights</small>
                                            <span className="visually-hidden"> on {blog.name}</span>
                                        </Link>
                                    </div>
                                </div>
                            ))}
                        </HydrationSafeSlider>

                        <div className="home-blog-cta text-center">
                            <div className="default-btn reverse-btn">
                                <Link to={"/blogs"} className="theme-btn"> <span>view all</span></Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
